var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlayAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89053 18.9399C5.2318 18.9399 5.52187 18.8087 5.86314 18.6201L15.811 13.0946C16.5192 12.6929 16.7666 12.4306 16.7666 11.9961C16.7666 11.5616 16.5192 11.2993 15.811 10.9058L5.86314 5.37207C5.52187 5.18352 5.2318 5.06055 4.89053 5.06055C4.25919 5.06055 3.86674 5.51964 3.86674 6.23287V17.7593C3.86674 18.4726 4.25919 18.9399 4.89053 18.9399Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6686 13.5771C19.6569 12.9982 20.0023 12.6202 20.0023 11.9941C20.0023 11.368 19.6569 10.99 18.6686 10.4229L4.78416 2.44891C4.30785 2.1772 3.90299 2 3.42668 2C2.5455 2 1.99775 2.66155 1.99775 3.68931V20.2989C1.99775 21.3266 2.5455 22 3.42668 22C3.90299 22 4.30785 21.811 4.78416 21.5393L18.6686 13.5771ZM5.77319 23.277C5.2598 23.5698 4.46234 24 3.42668 24C2.43525 24 1.49987 23.5994 0.847116 22.8153C0.227178 22.0706 0 21.1509 0 20.2989V3.68931C0 2.8369 0.227524 1.91565 0.853431 1.17126C1.51144 0.388695 2.44713 0 3.42668 0C4.44066 0 5.22215 0.396869 5.77319 0.711203L5.77825 0.714089L19.6619 8.68767C20.1863 8.98851 20.7739 9.36352 21.219 9.88024C21.7576 10.5056 22 11.2267 22 11.9941C22 12.7625 21.7571 13.4808 21.2228 14.1049C20.7819 14.6199 20.1988 14.998 19.6774 15.3034L19.6616 15.3126L5.77319 23.277Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayAlt);
export default __webpack_public_path__ + "static/media/icon-play-alt.ea67c0457ef9cb00b2266e46ab6fe2a0.svg";
export { ForwardRef as ReactComponent };